module.exports = __webpack_public_path__ + "img/noble-age.7f97c4bf.png";